import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[queryVisibilityButton]" })
export class QueryVisibilityButtonDirective {
  constructor(public template: TemplateRef<any>) {}
}
